import React from 'react';
import {
  Box, Button, FormHelperText, Typography,
} from '@mui/material';
import { Trans, useTranslation } from '@gamiphy/react-i18n';
import { observer } from 'mobx-react';
import { useTheme } from '@mui/material/styles';
import { isAxiosError } from 'axios';
import { WheelDto, WheelOptionDto } from '@coretava/api/events-service';
import { CampaignUserStore } from '@gamiphy/loyalty-station-desktop/store/campaignUsers';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { useSpinTheWheelApi } from '@gamiphy/loyalty-station-desktop/hooks/apis';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { WheelStore } from '@gamiphy/loyalty-station-desktop/store/campaignUsers/wheel';
import Wheel from './Wheel';
import SpinTheWheelText from './assets/SpinTheWheelText';

const WheelForm: React.FC<{ wheel: WheelDto }> = ({ wheel }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const spinTheWheelApi = useSpinTheWheelApi();
  const [error, setError] = React.useState<string>();
  const [resultOption, setResultOption] = React.useState<WheelOptionDto>();

  const handleSpin = React.useCallback(async () => {
    if (AppStore.app && WheelStore.wheel) {
      try {
        const { data } = await spinTheWheelApi.wheelSpinsControllerCreate(AppStore.app.id, { wheelId: WheelStore.wheel.id, userId: UserStore.user?.id });
        setResultOption(data.wheelSpin.option);
      } catch (e) {
        if (isAxiosError(e)) {
          switch (e.response?.status) {
            case 409:
              setError(t('campaigns.boosters.wheel.alreadySpun', "You've already spun the wheel! Thanks for participating!"));
              break;
            default:
              throw e;
          }
        }
      }
    }
  }, [AppStore.app, WheelStore.wheel, UserStore.user]);

  const handleClick = React.useCallback(() => {
    if (!UserStore.user?.phone) {
      UiStore.openSignupPopup();
    } else {
      void handleSpin();
    }
  }, [UserStore.user?.phone, handleSpin]);

  return (
    <Box height="100%" sx={{ overflowX: 'hidden' }} width="100%" display="flex" flexDirection="column" gap={3} alignItems="center" textAlign="center">
      <Box mt={2}>
        <SpinTheWheelText color={theme.palette.primary.main} width={160} height="auto" />
        <Typography fontSize={14} fontWeight={500}>
          <Trans i18nKey="campaigns.boosters.wheel.getPrize" defaults="Get your chance to win a prize!" />
        </Typography>
      </Box>
      <Box mt={2}>
        <Wheel afterRotation={() => CampaignUserStore.fetchCampaignUsers()} wheel={wheel} resultOption={resultOption} />
      </Box>
      {error && (
        <FormHelperText error>
          {error}
        </FormHelperText>
      )}
      <Button variant="contained" fullWidth onClick={handleClick}>
        <Trans i18nKey="campaigns.boosters.wheel.widget.try" defaults="Try your luck!" />
      </Button>
    </Box>
  );
};

export default observer(WheelForm);
